export enum TrackPageNameConfig {
  LOGIN_PAGE = 'login_page',
  FRONT_PAGE = 'front_page',
  MY_MEETINGS_PAGE = 'my_meetings_page',
  MY_FAVOURITES_PAGE = 'my_favourites_page',
  MY_ARTICLES_PAGE = 'my_articles_page',
  RECYCLE_BIN_PAGE = 'recycle_bin_page',
  RECORDING_AUDIO_PAGE = 'recording_audio_page',
  UPLOADING_AUDIO_PAGE = 'uploading_audio_page',
  TRANSCRIBE_AUDIO_PAGE = 'transcribe_audio_page',
  CROSS_MEETING_SUMMARY_PAGE = 'cross-meeting_summary_page',
  MEETING_DETAIL_PAGE = 'transcript_summary_page',
  MEETING_ASSISTANT_PAGE = 'meeting_assistant_page',
  MEETING_ASSISTANT_HISTORY_PAGE = 'meeting_assistant_history_page',
  MY_HOT_WORDS_PAGE = 'my_hot_words_page',
}

export enum CoreOperateConfig {
  CONFIRM_RESET_PASSWORD = 'confirm_reset_password',
  LOGIN_PAGE = 'login_page',
  LOGIN_SUBMIT = 'login_submit',
  CLICK_LANGUAGE = 'click_language',
  CLICK_UPLOAD_AUDIO = 'click_upload_audio',
  CLICK_RECORD_AUDIO = 'click_record_audio',
  CLICK_DELETE = 'click_delete',
  CLICK_FAVOURITE = 'click_favourite',
  CLICK_MEETING = 'click_meeting',
  CLICK_PERMANENT_DELETE = 'click_permanent_delete',
  SELECT_MEETING = 'select_meeting',
  CLICK_DELETE_SELECTED = 'click_delete_selected',
  CLICK_RESTORE = 'click_restore',
  CLICK_RECORD = 'click_record',
  SUBMIT_RECORD = 'submit_record',
  CLICK_UPLOAD = 'click_upload',
  SUBMIT_UPLOAD = 'submit_upload',
  CLICK_COPY = 'click_copy',
  CLICK_EDIT_TRANSCRIPT = 'click_edit_transcript',
  CLICK_DELETE_TRANSCRIPT = 'click_delete_transcript',
  CLICK_EDIT_SPEAKER = 'click_edit_speaker',
  CLICK_DOWNLOAD_TRANSCRIPT = 'click_download_transcript',
  CLICK_REGENERATE_SUMMARY = 'click_regenerate_summary',
  CLICK_COPY_SUMMARY = 'click_copy_summary',
  CLICK_DOWNLOAD_SUMMARY = 'click_download_summary',
  CLICK_SUMMARY_LANGUAGE = 'click_summary_language',
  CLICK_CONFIRM_GENERATION = 'click_confirm_generation',
  CLICK_COPY_ARTICLE = 'click_copy_article',
  CLICK_REGENERATE_ARTICLE = 'click_regenerate_article',
  CLICK_DOWNLOAD_ARTICLE = 'click_download_article',
  CLICK_SAVE = 'click_save',
  // 0.5.7 新增埋点
  CLICK_BACK = 'click_back',
  CLICK_TAB = 'click_tab',
  CLICK_SEND_EMAIL = 'click_send_email',
  CLICK_FEEDBACK = 'click_feedback',
  CLICK_EDIT_TITLE = 'click_edit_title',
  CLICK_CHAT_SEND = 'click_chat_send',
  CLICK_CHAT_COPY = 'click_chat_copy',
  CLICK_CHAT_EDIT = 'click_chat_edit',
  CLICK_CHAT_RETRY = 'click_chat_retry',
  CLICK_CHAT_ATTACH_FILE = 'click_chat_attach_file',
  CLICK_CHAT_REMOVE_FILE = 'click_chat_remove_file',
  CLICK_CHAT_HISTORY = 'click_chat_history',
  CLICK_CHAT_DELETE = 'click_chat_delete',
  CLICK_SELECT_MEETING = 'click_select_meeting',
  CLICK_SAVE_HOT_WORDS = 'click_save_hot_words',
  CLICK_START_RECORDING = 'click_start_recording',
  CLICK_STOP_RECORDING = 'click_stop_recording',
}

export enum PageViewConfig {
  PAGE_SHOW = 'page_show',
}

export enum OtherOperateConfig {
  USER_ACTIVE = 'user_active',
  SUBMIT_OFFLINE_AUDIO = 'submit_offline_audio',
  SUBMIT_ONLINE_AUDIO = 'submit_online_audio',
  OFFLINE_PROCESSING_SUCCESS = 'offline_processing_success',
  ONLINE_PROCESSING_SUCCESS = 'online_processing_success',
  ASR_PROCESSING_TIME = 'asr_processing_time',
  SUMMARY_GENERATION_TIME = 'summary_generation_time',
  FIRST_WORD_RESPONSE = 'first_word_response',
  TRANSCRIBE_AUDIO = 'transcribe_audio',
}
